import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";

/* import RecentSales from "../Recent/RecentSales";
import CardFilter from "../CardFilter";
import ProductosTable from "./ProductosTable"; */
import { FaPlus } from "react-icons/fa6";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { MdOutlineFileDownload } from "react-icons/md";
import styles from "./../tooltip.module.css";
import buttonStyles from "../../../../styles/Button.module.css";
import menuStyle from "../../../../styles/Menu.module.css";
import "./productosTable.css";
import "./../htmlTable.css";

import * as api from "helper/helper";
import CreateProveedor from "./CreateProveedor";
import SearchBar from "../SearchBar";

import TableOptionCheck from "./TableOptionCheck";
import { PermissionsForSection } from "../auth";

import { Sections } from "../../data/navItem";
import PagedFetch, {
  buildPageButtonsInfo,
  Init,
} from "../../helperFunctions/PagedFetch";
import FilterButton from "../FilterButton/FilterButton";
import ProveedoresTable from "./ProveedoresTable";
import { handleStatus } from "../../helperFunctions/helpers";
import ExportCSV from "../ExportCSV";
/*
function SectionOption(id = "", title = "", isSelected = false) {
  this.id = id;
  this.title = title;
  this.isSelected = isSelected;
}*/

function ProveedoresCatalogo({ subSectionId }) {
  const Menus = {
    Status: 0,
  };

  const StatusValues = {
    Activo: 0,
    Inactivo: 1,
  };

  const createProveedorRef = useRef();
  const filtrosRef = useRef([]);
  const csvRef = useRef();

  const [modalData, setModalData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [productos, setProductos] = useState([]);
  const [tags, setTags] = useState([]);
  const [marcas, setMarcas] = useState([]);

  const [permissions, setPermissions] = useState({
    canCreate: true,
    canEdit: true,
    canVerDetalle: true,
  });

  const [status, setStatus] = useState([
    {
      nombre: "Activo",
      value: StatusValues.Activo,
      id: 1,
      pos: 0,
      checked: false,
    },
    {
      nombre: "Inactivo",
      value: StatusValues.Inactivo,
      id: 2,
      pos: 1,
      checked: false,
    },
    //  { nombre: "Draft", value: "draft", id: 3 },
  ]);

  const [filtros, setFiltros] = useState([
    /*  { type: Menus.Marca, name: "Marca" },
    { type: Menus.Tags, name: "Etiquetado con" },*/
    {
      type: Menus.Status,
      name: "Estatus",
    },
    /* { type: "add_filter", name: "Agregar filtro" },*/
  ]);

  /** PAGING */
  const [searchCriteria, setSearchCriteria] = useState({});
  const [pageButtons, setPageButtons] = useState([Init.Vars.PageButtons]);

  ///start changes CLASS
  const pagingInfoRef = useRef(new PagedFetch());
  const [responsePagingInfo, setResponsePagingInfo] = useState({
    ...Init.Vars.ResponsePagingInfo,
  });

  const fetchData = async (resetPageNumber = true) => {
    let criteria = searchCriteria;

    if (resetPageNumber) {
      /// reset pag info
      pagingInfoRef.current.resetPageInfo();
    }

    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);
  };

  const fetchCatalogos = async () => {
    setIsLoading(true);
    const responseMarcas = await api.marcas().catch((error) => {
      toast.error("Error al pedir marcas.");
      setIsLoading(false);
    });
    if (!responseMarcas) return;

    setMarcas(responseMarcas.data);

    const responseTags = await api.tags().catch((error) => {
      toast.error("Error al pedir tags.");
      setIsLoading(false);
    });
    if (!responseTags) return;

    setTags(responseTags.data);
    setFiltros([...filtros]);

    setIsLoading(false);
  };

  useEffect(() => {
    fetchData();
    fetchCatalogos();

    const newPermissions = PermissionsForSection(Sections.Productos);
    setPermissions(newPermissions);
  }, []);

  function createProducto(event) {
    console.log(event);
    loadItem({});
  }

  function reloadProveedores() {
    fetchData(false);
  }

  function loadItem(item) {
    if (!permissions.canVerDetalle) return;

    setModalData(item);

    createProveedorRef.current.toggleModal();
  }

  /**
   * Search handler
   */

  const handleOnChange = (value) => {
    console.log("-->");

    let criteria = searchCriteria;
    let tagIds = [];
    let name = "";

    if (value != null && value.id != null) {
      tagIds = criteria["marcaIds"] ?? [];
      let tagId = value.id;
      if (!tagIds.includes(tagId)) {
        tagIds.push(tagId);
      } else {
        tagIds = tagIds.filter((f) => f !== tagId);
      }

      name = value.value;
    }

    criteria["marcaIds"] = tagIds;
    setSearchCriteria(criteria);

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);

    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.Tags;
    });
    filtrosRef.current[index].toka(name);
    filtrosRef.current[index].hideMenu();
  };

  const onChangeSearchText = (e) => {
    console.log("text search change " + e);

    let criteria = searchCriteria;

    criteria["texto"] = e;

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);

    searchFetchData(criteria);
  };

  function clearCallback(item) {
    filtros.forEach((value, index) => {
      if (value.type === Menus.Status && item.type === Menus.Status) {
        clearStatusFilter();
      }
    });
  }

  const handleMarcaClick = (event, item, options) => {
    let criteria = searchCriteria;
    let nivelIds = criteria["marcaIds"] ?? [];

    let itemId = item.id;
    if (event.currentTarget.checked && !nivelIds.includes(item.id)) {
      nivelIds.push(itemId);
    } else if (!event.currentTarget.checked && nivelIds.includes(item.id)) {
      nivelIds = nivelIds.filter((f) => f !== itemId);
    }

    updateMarcasCriteria(nivelIds);
  };

  const updateMarcasCriteria = (nivelIds) => {
    let criteria = searchCriteria;

    criteria["marcaIds"] = nivelIds;
    setSearchCriteria(criteria);

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.Marca;
    });

    if (index === -1) {
      return;
    }
    var marcasNames = "";
    if (nivelIds.length > 0) {
      //
      const marcasFilter = marcas.filter((currItem) => {
        return nivelIds.includes(currItem.id);
      });

      marcasNames = marcasFilter
        .map(function (depa) {
          return depa.nombre;
        })
        .join(", ");
    }

    filtrosRef.current[index].toka(marcasNames);
  };

  const clearStatusFilter = () => {
    status.forEach((item) => {
      item.checked = false;
    });

    setStatus(status.slice());

    updateStatusCriteria(undefined);

    filtrosRef.current[Menus.Status].hideMenu();
  };

  const handleStatusClick = (event, item, options) => {
    item.checked = !item.checked;

    const isActivo = status.find((item) => {
      return item.value === StatusValues.Activo && item.checked;
    })?.checked;
    const isInactivo = status.find((item) => {
      return item.value === StatusValues.Inactivo && item.checked;
    })?.checked;

    let checked = isActivo;
    if (!(isActivo ^ isInactivo)) {
      //delete criteria["isActivo"];
      checked = undefined;
    } else {
      //let checked = isActivo;
      if (isInactivo) {
        checked = false;
      }
      //criteria["isActivo"] = checked;
    }

    updateStatusCriteria(checked);
  };

  const updateStatusCriteria = (statusValue) => {
    let criteria = searchCriteria;
    if (statusValue === undefined) {
      delete criteria["isActivo"];
    } else {
      criteria["isActivo"] = statusValue;
    }
    setSearchCriteria(criteria);

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);

    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.Status;
    });

    if (index === -1) {
      return;
    }
    var statusNames = "";
    //
    const statuses = status.flatMap((currItem, index) => {
      return currItem.checked ? currItem.nombre : [];
    });

    statusNames = statuses.join(", ");

    filtrosRef.current[index].toka(statusNames);
  };

  const searchFetchData = async (criteria) => {
    setIsLoading(true);
    const response = await api.searchProveedores(criteria).catch((error) => {
      toast.error("Error al buscar Proveedores.");
      setIsLoading(false);
    });
    if (!response) return;

    const { totalPages, count, isFirstPage, isLastPage } = response.data;

    const { rangePage, newPageNumber } = buildPageButtonsInfo(response.data);
    pagingInfoRef.current.updatePageNumber(newPageNumber);

    setPageButtons(rangePage);

    setResponsePagingInfo({
      count,
      isFirstPage,
      isLastPage,
      pageNumber: newPageNumber,
      totalPages,
    });

    setProductos(response.data.subset);

    setIsLoading(false);
  };

  const previousPageState = responsePagingInfo.isFirstPage
    ? "disabled disable-paging-btn"
    : "";
  const nextPageState = responsePagingInfo.isLastPage
    ? "disabled disable-paging-btn"
    : "";

  function goPreviousPage() {
    let page = pagingInfoRef.current.pageNumber();
    page -= 1;
    goToPage(page);
  }

  function goNextPage() {
    let page = pagingInfoRef.current.pageNumber();
    page += 1;
    goToPage(page);
  }

  function goToPage(pageNumber) {
    let criteria = searchCriteria;
    pagingInfoRef.current.updatePageNumber(pageNumber);
    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);
  }

  function handleSortChange({ sortBy, sortAsc }) {
    if ((sortBy?.length ?? 0) === 0) {
      return;
    }
    let criteria = searchCriteria;
    criteria["sortBy"] = sortBy;
    criteria["sortAsc"] = sortAsc === "asc";

    setSearchCriteria(criteria);

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);
  }

  function generateFile(event) {
    //TODO: generar CSV con los filtros seleccionados

    const csvString = [
      [
        "Id",
        "Nombre",
        "RFC",
        "Banco",
        "Cuenta",
        "Email",
        "Telefono",
        "Estatus",
      ], // Specify your headers here
      ...productos.map((item) => {
        const id = item.numProveedor ?? "";

        return [
          id,
          item.nombre ?? "",
          item.rfc ?? "",
          item.banco ?? "",
          item.numCuenta ?? "",
          item.email ?? "",
          item.telefono ?? "",
          handleStatus(item).text,
        ];
      }),
    ] // Map your data fields accordingly
      .map((row) => row.join(","))
      .join("\n");

    csvRef.current.downloadCSV(csvString, "productosProveedores.csv");
  }

  return (
    <>
      <ExportCSV ref={csvRef} />

      <div className="card recent-sales overflow-auto">
        <div className="separator"></div>
        <div className="">
          <div
            className="container-fluid"
            style={{ paddingLeft: "20px", paddingRight: "20px" }}
          >
            <div className="header">
              <SearchBar
                onChange={(e) => onChangeSearchText(e)}
                placeholder="Buscar por Id, Nombre y/o RFC..."
              />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                marginTop: "10px",
                gap: "10px",
              }}
            >
              <button
                className={`btn btn-info ${styles.tooltip}`}
                onClick={(event) => generateFile(event)}
                style={{ marginLeft: "0px" }}
                disabled={isLoading}
              >
                <div>
                  <span className={`${styles.tooltiptext}`}>Descargar CSV</span>
                  <MdOutlineFileDownload />
                </div>
              </button>
              <button
                className="btn btn-primary"
                onClick={createProducto}
                hidden={!permissions.canCreate}
              >
                <div className={buttonStyles.icon_button}>
                  <FaPlus />
                  Crear Proveedor
                </div>
              </button>
            </div>

            <div
              className="btn-group1"
              style={{ display: "flex", columnGap: "6px" }}
            >
              {filtros.map((item, index) => {
                return (
                  <>
                    <FilterButton
                      key={index}
                      ref={(el) => (filtrosRef.current[index] = el)}
                      name={item.name}
                      clearCallback={(ble) => clearCallback(item)}
                    >
                      <ul
                        className={`dropdown-menu ${menuStyle.height_50_scroll}`}
                        aria-labelledby="dropdownMenuClickableInside"
                      >
                        {item.type === Menus.Status &&
                          status.map((item, index) => {
                            return (
                              <TableOptionCheck
                                key={index}
                                item={item}
                                onClick={handleStatusClick}
                              />
                            );
                          })}
                      </ul>
                    </FilterButton>
                  </>
                );
              })}
            </div>
          </div>
        </div>

        <nav
          aria-label="Page navigation example"
          style={{ marginRight: "20px" }}
        >
          <ul className="pagination justify-content-end">
            <li
              className={`page-item ${previousPageState}`}
              onClick={(event) => goPreviousPage()}
            >
              <a
                className="page-link"
                href="#"
                tabIndex="-1"
                aria-disabled={"true"}
              >
                <FaArrowLeft />
              </a>
            </li>

            {pageButtons.map((item) => {
              let page = pagingInfoRef.current.page;
              let disabled =
                page === item.pageNumber ? "disabled disable-paging-btn" : "";
              return (
                <li
                  className={`page-item ${disabled}`}
                  onClick={(event) => goToPage(item.pageNumber)}
                >
                  <a className="page-link" href="#">
                    {item.name}
                  </a>
                </li>
              );
            })}
            <li
              className={`page-item ${nextPageState}`}
              onClick={(event) => goNextPage()}
            >
              <a className="page-link" href="#">
                <FaArrowRight />
              </a>
            </li>
          </ul>
        </nav>

        <div className="card-body">
          <ProveedoresTable
            items={productos}
            openItem={loadItem}
            handleSortChange={handleSortChange}
            isLoading={isLoading}
          />
        </div>

        <CreateProveedor
          ref={createProveedorRef}
          item={modalData}
          reloadProveedor={reloadProveedores}
        />
      </div>
    </>
  );
}

export default ProveedoresCatalogo;
